import { z } from 'zod';
import { Uuid } from './common.js';
/**
 * Text messages: the BulkSMS provider and the per-tenant monthly limit (task p4/sms, Perry 25 Oct 2026).
 * The limit counts SMS segments in the calendar month (UK time). 0 = no text messages for that customer.
 */
/** Largest limit the platform admin can set (a sanity cap, not a business rule). */
export const SMS_LIMIT_MAX = 10_000_000;
export const SmsMonthlyLimit = z.number().int().min(0).max(SMS_LIMIT_MAX);
/** One customer's limit and use this month (platform console and tenant view). */
export const SmsUsageStatus = z.object({
    /** 0 = no text messages. */
    limit: z.number().int(),
    used: z.number().int(),
    /** The calendar month (UK time) the use is for, YYYY-MM. */
    month: z.string().regex(/^\d{4}-\d{2}$/),
});
export const SmsLimitUpdate = z.object({ smsMonthlyLimit: SmsMonthlyLimit });
export const SmsLimitParams = z.object({ id: Uuid });
/** Platform: which provider sends text messages and its credentials. The token id and secret are write-only. */
export const BulkSmsProviderKey = z.enum(['off', 'log', 'bulksms']);
export const BulkSmsPlatformStatus = z.object({
    provider: BulkSmsProviderKey,
    /** BulkSMS "from" name or number; empty = BulkSMS default. Up to 11 characters. */
    senderId: z.string(),
    tokenIdSet: z.boolean(),
    tokenSecretSet: z.boolean(),
    /** Lone-worker alarms and evacuation texts keep sending past a customer's limit. */
    safetyBypassesLimit: z.boolean(),
    /** True when texts are really sent (provider bulksms with both token parts set). */
    live: z.boolean(),
});
export const BulkSmsPlatformUpdate = z.object({
    provider: BulkSmsProviderKey.optional(),
    senderId: z.string().trim().max(11).optional(),
    /** Never returned. */
    tokenId: z.string().trim().min(1).max(200).optional(),
    /** Never returned. */
    tokenSecret: z.string().trim().min(1).max(400).optional(),
    safetyBypassesLimit: z.boolean().optional(),
});
//# sourceMappingURL=sms.js.map